module.exports = __webpack_public_path__ + "img/mercado_pago.8474ab8e.png";